import { RELATION_HAS_PART } from '@backstage/catalog-model';
import { EntityRelatedEntitiesGridItem } from './EntityRelatedEntitiesGridItem';
import { EntityTable } from '@backstage/plugin-catalog-react';
import { EntityGridItemProps } from './EntityGridItemProps';

export const HasSystemsGridItem = (props: EntityGridItemProps) => {
  return (
    <EntityRelatedEntitiesGridItem
      {...props}
      relationFilter={{
        type: RELATION_HAS_PART,
        kind: 'System',
      }}
      title={props.title ?? 'Has systems'}
      columns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'system' }),
        EntityTable.columns.createOwnerColumn(),
      ]}
      lgColumns={[
        EntityTable.columns.createEntityRefColumn({ defaultKind: 'system' }),
        EntityTable.columns.createOwnerColumn(),
        EntityTable.columns.createMetadataDescriptionColumn(),
      ]}
    />
  );
};
